import { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import ToastContainer from './components/Toast/ToastContainer';
import PayrollPage from './pages/admin/PayrollPage';
import StaffSchedulerPage from './pages/admin/StaffSchedulerPage';
import BranchManagementPage from './pages/admin/BranchManagementPage';
import LeaveManagementPage from './pages/admin/LeaveManagementPage';
import StaffProfilesPage from './pages/admin/StaffProfilesPage';
import SpinTheWheelPage from './pages/admin/SpinTheWheelPage';
import DTR from './components/DTR';
import TimeRecordList from './components/TimeRecordList';
import Profile from './components/Profile';
import ThirstyRecords from './components/ThirstyRecords';
import Payslips from './components/Payslips';
import Leaderboard from './components/Leaderboard';

const App: FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<DTR />} />
            <Route path="list" element={<TimeRecordList />} />
            <Route path="profile" element={<Profile />} />
            <Route path="thirsty" element={<ThirstyRecords />} />
            <Route path="payslips" element={<Payslips />} />
            <Route path="admin/payroll" element={<PayrollPage />} />
            <Route path="admin/scheduler" element={<StaffSchedulerPage />} />
            <Route path="admin/branches" element={<BranchManagementPage />} />
            <Route path="admin/leaves" element={<LeaveManagementPage />} />
            <Route path="admin/staff-profiles" element={<StaffProfilesPage />} />
            <Route path="admin/spin-wheel" element={<SpinTheWheelPage />} />
            <Route path="leaderboard" element={<Leaderboard />} />
          </Route>
        </Routes>
        <ToastContainer />
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
